'use strict';

let moment = require('moment-timezone');
let themes = require('../../../common/data/themes');
import {unionBy,differenceBy,findIndex} from 'lodash';
import _ from 'lodash';
import TemplateService from '../../../services/email/TemplateService';
import { goToDynamicURL } from '../../../modules/emails/util';
import {
    userManagementAllowed,
    emailAlertsAdminAllowed
} from '../../../modules/app/site/featureAccessControl';

angular.module('clientDashboardApp').controller("EmailAlertEditorCtrl", function(
  $scope, $timeout, $q, $uibModal, emailAlertService, $log, reactContainer
){

  const { alertId, mode, alert, sessionUser, accounts, userRoles, providers, defaultEmailAlertTemplatesData, emailAlertConfig, userManagementAllowed } = reactContainer.getContainer();

  let templateService = new TemplateService();
  $scope.isAdmin = emailAlertsAdminAllowed();
  $scope.hasUserManagement = userManagementAllowed();
  $scope.errorMessage = null;
  $scope.emailTemplateList = defaultEmailAlertTemplatesData;
  $scope.mode = mode;
  $scope.template = null;
  $scope.scssModel = ""
  $scope.customCss = ""
  $scope.htmlUpdateCount = 0
  $scope.htmlEditorPristine = true
  $scope.gadgetHbsIntact = true

  $scope.providers = providers;
  $scope.userRoles = userRoles.filter(role => role.roleName !== 'ResellerAdmin' || $scope.userInfo.userType === 'ResellerAdmin') // Hide reseller role from non-resellers

  $scope.accounts = accounts;

  $scope.days = _.range(1, 32)
  $scope.weekdayNames = ["Mon", "Tues", "Wed", "Thur", "Fri", "Sat", "Sun"]
  $scope.HOURS = _.range(0, 24)
  $scope.TIMEZONES = moment.tz.names().filter(tz => (tz.indexOf('US/') === 0 ))
  $scope.SCHEDULE_TYPES = ["Monthly", "Weekly", "Daily"]

  $scope.calendarView = 'month'
  $scope.viewDate = Date.now()
  $scope.events = []

  $scope.sampleData = emailAlertConfig.data.SAMPLE_DATA

  $scope.gadgetSelectorOpen = false
  $scope.tabWidthHack = {
    refreshTabWidth:0
  }
  $scope.nextAttemptFailed = false

  let iframeId = "#alertPreview"
  let user = sessionUser;

  $scope.themes = themes

  $scope.TABS = [
    {name:'Preview', key:'preview', view:'iframe'},
    {name:'HTML', key:'html', view:'editor'},
    {name:'SCSS', key:'scss', view:'editor'}
  ]

  $scope.forms = {}

  $scope.unselectedGadgets = [];

  $scope.aceModel = {
    html : ""
  }

  // The modes
  $scope.modes = ['html', 'css'];
  $scope.mode = $scope.modes[0];

  // Initial code content...
  $scope.aceModel = {
    "html" : $scope.aceModel.html,
    "css" : $scope.scssModel
  }

  $scope.templatePristine = true;

  const getInitializedRecipients = (isAdmin) => {
    // If a standard user, then initialize recipients with single user, the current user
    const userIds = isAdmin || userManagementAllowed() ? [] : [sessionUser.userId]

    return {
      role: {
        type: "byRole",
        roles: []
      },
      specificUsers: {
        type: "specificUsers",
        userIds
      }
    }
  }

  const initializedRecipients = getInitializedRecipients($scope.isAdmin, userManagementAllowed())

  const defaultAlert = {
    name: "",
    subject: "",
    headerText: "",
    footerText: "",
    logo: null,
    schedule : {
      firstDelivery: null,
      scheduleDay:[1],
      scheduleType:"Daily",
      deliveryHour:0,
      deliveryTimeZone:"US/Pacific"
    },
    excludeUsers: [],
    recipients: [initializedRecipients.role,initializedRecipients.specificUsers],
    theme: null,
    gadgets: [],
    accounts: [$scope.accounts[0]],
    providers: [],
    createdBy: mode === 'Add' ? user.userId : null,
    isSplitByLocation: false
  }

  $scope.alert = angular.copy(alert) || angular.copy(defaultAlert);

  let pristineAlert = angular.copy($scope.alert)
  initializeRecipientField()

  $scope.alertTabs = [
    {
      id: 'Templates',
      name: 'Templates',
      iconClass: 'fas fa-file'
    },
    {
      id: 'Settings',
      name: 'Settings',
      iconClass: 'fas fa-cog'
    },
    {
      id: 'Design',
      name: 'Design',
      iconClass: 'fas fa-paint-brush'
    }
  ]

  $scope.minDate = Date.now()

  $scope.refreshAlert = () => {
    $scope.alert = pristineAlert
  }

  $scope.selectedAlertTab = mode === 'Add' ? $scope.alertTabs[0].id : $scope.alertTabs[1].id
  $scope.selectAlertTab = (id, form) => {
    if($scope.handleFailedNavAttempt(form,$scope.disableTab(id))){
      return;
    }
    if($scope.selectedAlertTab !== id){
      $scope.nextAttemptFailed = false;
    }

    if (id === "Templates" && (!$scope.templatePristine || mode === 'Edit')) {
      if($scope.ignoreTemplateWarning){
        $scope.selectedAlertTab = id;
        return
      }
      let $parentScope = $scope

      var modalInstance = $uibModal.open({
        animation: true,
        ariaLabelledBy: 'modal-title',
        ariaDescribedBy: 'modal-body',
        template:`
        <div class="modal-header">
          <h3 class="modal-title" id="modal-title"><span class="ss-alert" style="position: relative;top: 3px;"></span> Warning</h3>
        </div>
        <div class="modal-body" id="modal-body">
          <p>Selecting another template will override your current changes</p>
        </div>
        <div class="modal-footer d-flex align-items-center">
            <span class="checkbox d-flex align-items-center">
              <label class="checkbox-inline d-flex align-items-center mb-0"><input type="checkbox" class="fancy-checkbox" ng-model="ignoreTemplateWarning">&nbsp;Don't show again</label>
            </span>
            <button class="btn btn-outline-secondary" type="button" ng-click="cancel()">Cancel</button>
            <button class="btn btn-secondary" type="button" ng-click="ok()">OK</button>
        </div>`,
        controller: ($scope,$uibModalInstance) => {

          $scope.$watch('ignoreTemplateWarning',(newVal,oldVal) => {
            if(newVal !== oldVal){
              $parentScope.ignoreTemplateWarning = newVal
            }
          })

          $scope.ok = function () {
            $uibModalInstance.close()
            $parentScope.refreshAlert()
          };

          $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
          };
        },
        size: "md"
      });

      modalInstance.result.then(function () {
        $scope.selectedAlertTab = id;
      }, function () {
        $log.info('Modal dismissed at: ' + new Date());
      });

    } else {
      $scope.selectedAlertTab = id;
      $timeout(() => {
        previewAlert()
      })
    }
  }

  const updateDayRange = (type) => {
    switch(type) {
      case "Monthly":
        $scope.days = _.range(1,32);
        break;
      case "Weekly":
        $scope.days = _.range(1,8);
        break;
      default:
        break;
    }
  }

  /*Questionable Fields*/

  $scope.isAlertDirty = true;
  $scope.showVisibility = false//isSharedDefault || _.includes(user.permissions, 'UserManagement');
  $scope.themes = themes;
  $scope.mode = mode;
  $scope.npsFlag = false;


  $scope.accountConfig = {
    required : true,
    accountId : null,
    disableDropdown: $scope.mode === "edit",
    showAccountSelection: false,
    editPage: true
  };

  $scope.selectedTabType = "emailAlert"

  $scope.selectedSampleAlert = {
    id : $scope.mode === "create" ? "default" : alertId
  };

  $scope.scheduleTypeIsNotDisabledForGadget = (scheduleType, gadget) => {
    return !(gadget.disabledScheduleTypes || []).includes(scheduleType)
  }

  const filterDisabledGadgets = () => {
    // Remove any gadgets that are not available for the selected SCHEDULE_TYPE
    if ($scope.alert && $scope.alert.schedule && Array.isArray($scope.alert.gadgets)) {
      $scope.alert.gadgets = $scope.alert.gadgets.filter(gadget => {
        return $scope.scheduleTypeIsNotDisabledForGadget($scope.alert.schedule.scheduleType, gadget)
      })
      partitionGadgetsByType()
      updateUnselectedGadgets()
    }
  }

  /* Initialization */

  $scope.previewAlert = _.debounce(previewAlert, 400);

  initializeAlert()
  initializeGadgets()

  function initializeGadgets() {
    filterDisabledGadgets()
    partitionGadgetsByType()
    removeHref()
    updateUnselectedGadgets()
    compilePartials()
    $scope.previewAlert()
  }

  function partitionGadgetsByType() {
    if($scope.alert.gadgets) {
      $scope.locationSpecificGadgets = $scope.alert.gadgets.filter(gadget => (gadget.locationSpecific))
      $scope.nonLocationSpecificGadgets = $scope.alert.gadgets.filter(gadget => (!gadget.locationSpecific))
    }
  }

  $scope.filters = {}
  $scope.ignoreTemplateWarning = false

  $scope.initializeLocations = () => {
    if (alert) {
      $scope.filters.locations = [];
      if (alert.filter.groupIds) { alert.filter.groupIds.forEach(g => $scope.filters.locations.push(`group-${g}`)) }
      if (alert.filter.locationIds) { alert.filter.locationIds.forEach(l => $scope.filters.locations.push(`location-${l}`)) }
    }
  }

  $scope.initializeLocations()

  function updateTheme(theme) {
    if(theme) {
      $scope.alert.theme = theme
    }
    if($scope.alert.theme) {
      updatePreviewCss()
      updateAlertStylesheet()
    }
  }

  $scope.updateTheme = updateTheme

  function updateAlertStylesheet() {
    let selectedThemeSection = $scope.alert.theme ? `/*BEGIN-SELECTED-THEME themeId='${$scope.alert.theme.id}'*/\n${$scope.alert.theme.style}\n/*END-SELECTED-THEME*/\n` : "";
    let customScssSection = `/*BEGIN-CUSTOM-SCSS*/\n${$scope.scssModel || ''}\n/*END-CUSTOM-SCSS*/\n`
    $scope.alert.stylesheet = templateService.defaultCssSection + selectedThemeSection + customScssSection;
  }

  $scope.tabSelected = tab => {
    switch(tab) {
      case "preview":
        previewAlert()
        break;
    }
  }

  /*Logo Stuff*/

  $scope.injectLogo = injectLogo

  function injectLogo(logo, init) {
    $scope.alert.logo = init ? logo : logo.url
    $scope.sampleData.resellerLogo = $scope.alert.logo
    previewAlert()
  }

  function initializeLogo() {
    if($scope.alert.logo) {
      injectLogo($scope.alert.logo,true)
    }
  }

  $scope.handleFailedNavAttempt = (form,failCondition) => {
    if(failCondition){
      $scope.nextAttemptFailed = true
      scrollToFirstInvalidField(form)
    }
    return failCondition
  }

  /* Injected Fields */

  $scope.updateInjectedField = _.debounce(updateInjectedField, 500);

  function updateInjectedField(fieldName) {
    $scope.sampleData[fieldName] = $scope.alert[fieldName]
    previewAlert()
  }

  function initializeInjectedFields() {
    updateInjectedField('headerText')
    updateInjectedField('footerText')
  }

  /* Navigation */

  $scope.next = (form) => {
    if($scope.handleFailedNavAttempt(form,$scope.disableNext())) {
      return;
    }
    $scope.nextAttemptFailed = false
    $scope.selectedAlertTab = $scope.alertTabs[findIndex($scope.alertTabs,{id:$scope.selectedAlertTab}) + 1].id
    if($scope.selectedAlertTab === 'Design'){
      $timeout(() => {
        previewAlert()
      })
    }
  }


  function initializeAlert() {
    if ($scope.template) {
      $scope.alert.schedule = $scope.template.schedule
      $scope.alert.trigger = $scope.template.trigger
      $scope.alert.heading = $scope.template.heading
      $scope.sampleData.emailTitle = $scope.template.subject
      $scope.alert.isSplitByLocation = $scope.template.isSplitByLocation
    }
    if ($scope.alert.trigger) {
      $scope.providers = $scope.providers.filter(p => p.providerSettings.realTimeReviews)
      $scope.GADGETS = emailAlertConfig.realtimeData.GADGETS
    } else {
      $scope.GADGETS = emailAlertConfig.data.GADGETS
    }

    if ($scope.alert.schedule && (!$scope.alert.schedule.scheduleDay || !$scope.alert.schedule.scheduleDay.length)) {
      $scope.alert.schedule.scheduleDay = [1]
    }

    $scope.alert.isSplitByLocation = $scope.alert.isSplitByLocation || false
    $scope.locationSpecificGadgetTypes = _.filter($scope.GADGETS, gadget => (gadget.locationSpecific)).map(gadget => (gadget.type))
    $scope.nonLocationSpecificGadgetTypes = _.filter($scope.GADGETS, gadget => (!gadget.locationSpecific)).map(gadget => (gadget.type))

    $scope.alert.gadgets = _.map($scope.alert.gadgets, (g) => {
      const staticGadgetData = _.find($scope.GADGETS, {type: g.type})
      // need to hydrate the filter data right here
      staticGadgetData.filters.forEach(filter => { // probably going to need some type hackery here
        if (typeof filter.initialize === "function") {
          filter.value = filter.initialize(g)
        }
      })
      return {...staticGadgetData, ...g}
    })

    initializeLogo()
    initializeInjectedFields()
    initializeStyles()
  }

  function initializeStyles() {
    if ($scope.alert.stylesheet) {

      let themeRegex = /\/\*BEGIN-SELECTED-THEME themeId='(.*)'/g;
      let customScssRegex = /\/\*BEGIN-CUSTOM-SCSS\*\/\n([\s\S]*)?\n\/\*END-CUSTOM-SCSS\*\//g;

      var themeMatch = themeRegex.exec($scope.alert.stylesheet);
      if(themeMatch && themeMatch.length) {
        $scope.alert.theme = $scope.themes.find(theme => (theme.id === themeMatch[1]))
      }

      var customScssMatch = customScssRegex.exec($scope.alert.stylesheet);
      if(customScssMatch && customScssMatch.length && customScssMatch[1] !== 'undefined') {
        emailAlertService.compileScss(customScssMatch[1]).then(resp => {
          $scope.customCss = resp.data.css
        })
        $scope.scssModel = customScssMatch[1]
      }
      updateTheme()
    }
  }

  $scope.scssEditorChanged = () => {
    $scope.scssModel = $scope.scssEditor.getSession().getValue()
    emailAlertService.compileScss($scope.scssModel).then(resp => {
      $scope.customCss = resp.data.css
      updatePreviewCss()
      updateAlertStylesheet()
    })
  }

  function updatePreviewCss() {
      let $head = $(iframeId).contents().find("head")

      if ($head.find('style#selected-theme')) {
        $head.find('style#selected-theme').remove()
      }
      if ($head.find('style#custom-css')) {
        $head.find('style#custom-theme').remove()
      }
      if($scope.alert.theme){
        $head.append('<style type="text/css" id="selected-theme">' + $scope.alert.theme.style + '</style>')
      }
      if($scope.customCss) {
        $head.append('<style type="text/css" id="custom-css">' + $scope.customCss + '</style>')
      }
  }

  $scope.disableTab = (tabId) => {
    if(tabId === 'Design'){
      return $scope.forms.settings ? $scope.forms.settings.$invalid : false;
    }
  }

  $scope.disableNext = () => {
    if($scope.selectedAlertTab  === 'Templates'){
      return false
    }
    else if($scope.selectedAlertTab === 'Settings'){
      return $scope.forms.settings ? $scope.forms.settings.$invalid : false;
    }
  }

  /* Handlebars Compilation*/

  function compilePartials() {
    templateService.delimitBy(['<%', '%>']);
    templateService.registerAllPartials();

    $scope.htmlUpdateCount = 0;
    let containerPartial = templateService.partialByName("container");
    let template = templateService.Handlebars.compile(containerPartial);

    if ($scope.alert && angular.isDefined($scope.alert.template) && $scope.templatePristine) {
      if($scope.htmlEditorPristine ) {
        $scope.aceModel.html = $scope.alert.template;
        setGadgetHbsIntact()
      }
      return;
    }
    $scope.aceModel.html = template();
  }

  function compileGadgetPartials(alert) {
    if (alert.gadgets) {
      templateService.delimitBy(['<%', '%>']);
      alert.gadgets.map(gadget => {
          gadget.template = templateService.handlebars.compile(gadget.template)()
        }
      );
      templateService.delimitBy(['{{', '}}']);
    }
    $scope.htmlUpdateCount = 0;
  }

  function compilePreview(dataOverride) {
    templateService.delimitBy(['{{', '}}']);
    let data = dataOverride || $scope.sampleData;
    let hbsPromises = {
      gadgets : emailAlertService.compileHbs(
        {
          template:getGadgetString(false),
          css: "",
          context: data,
          inline: false
        }
      ),
      locationGadgets : []
    };

    /*COMPILE GADGETS AND LOCATIONS*/
    data.locations.forEach(location => {
      hbsPromises.locationGadgets.push(emailAlertService.compileHbs(
        {
          template: getGadgetString(true),
          css: "",
          context: location,
          inline: false
        }).then( resp => {
          location.gadgets = resp.data.html
        })
      )
    });

    /*COMPILE TEMPLATE*/
    return $q.all([hbsPromises.gadgets].concat(hbsPromises.locationGadgets)).then((values) => {
      data.gadgets = values[0].data.html;
      return emailAlertService.compileHbs(
        {
          template:$scope.aceModel.html,
          css: "",
          context: data,
          inline: false
        }
      )
    })

  }


  function getGadgetString(locationSpecific) {
    if (!$scope.alert.gadgets) {
      return ""
    }

    const gadgetTemplateText = $scope.alert.gadgets.map( g => (locationSpecific ? g.locationSpecific : !g.locationSpecific) && (g.template || g.customTemplate) || '').join('');
    templateService.delimitBy(['<%', '%>']);
    let gadgetTemplate = templateService.handlebars.compile(gadgetTemplateText);
    const renderedTemplates = gadgetTemplate();
    templateService.delimitBy(['{{', '}}']);

    return renderedTemplates || '';
  }

  /*Ace Stuff*/

  $scope.aceLoaded = function(_editor) {
    // Options
    _editor.setReadOnly(true);
    _editor.resize();

    $scope.aceEditor = _editor
  };

  $scope.getAceOptions = (mode) => {
    return {
      mode,
      onLoad : function(editor) {}
    }
  };

  $scope.htmlEditorChanged = (e) => {
    $scope.htmlUpdateCount++;
    if($scope.htmlUpdateCount > 1){
      $scope.htmlEditorPristine = false
    }
    //$scope.aceModel.html = $scope.htmlEditor.getSession().getValue()
    setGadgetHbsIntact()
    $scope.previewAlert()
  }

  function setGadgetHbsIntact() {
    let gadgetRegex = /\{\{\{\s?gadgets\s?\}\}\}/g
    let match, matches = []
    while(match = gadgetRegex.exec($scope.aceModel.html) !== null) {
      matches.push(match)
    }
    $scope.gadgetHbsIntact = matches.length === 2
  }

  //TODO: These no longer need to be dynamic
  $scope.onHbsEditorLoaded = function(editor) {
    editor.setTheme("ace/theme/chrome");
    editor.getSession().setMode("ace/mode/handlebars");
    editor.setShowPrintMargin(false);
    editor.$blockScrolling = Infinity;
    $scope.htmlEditor = editor;
  };

  $scope.onScssEditorLoaded = function(editor) {
    editor.setTheme("ace/theme/chrome");
    editor.getSession().setMode("ace/mode/scss");
    editor.setShowPrintMargin(false);
    editor.$blockScrolling = Infinity;
    $scope.scssEditor = editor;
  };

  /* Template Selection*/

  $scope.selectTemplate = (template) => {
    $scope.template = template;
    $scope.alert.gadgets = template.gadgets;
    $scope.templatePristine = false;
    initializeAlert()
    initializeGadgets()
    $scope.selectedAlertTab = $scope.alertTabs[1].id;

    filterDisabledGadgets()
  }

  $scope.previewTemplate = function (template) {
    var modalInstance = $uibModal.open({
      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      template: require('./templatePreview.html'),
      controller: ($scope) => {
        $scope.template = template
      },
      size: "md"
    });
  };


  /* Alert Preview*/

  function previewAlert(gadget) {
    adaptPreviewAndEditorHeight()
    refreshEditorParentWidth()
    redrawIframe()
      .then(iframeExists => {
        updatePreviewCss()
        if(gadget){
          scrollToGadget(gadget)
        }
      })

  }

  function adaptPreviewAndEditorHeight() {
    $timeout(() => {
      let $tabContent = $('.tab-content')
      let tabWrapperHeight = $tabContent.outerHeight()
      let availableHeight = $(window).height() -60
      $('.cm-preview-container, #html-editor-wrapper, #scss-editor-wrapper').css({height:availableHeight+'px'})
      $scope.aceEditor && $scope.aceEditor.resize()
    }, 500)
  }

  function scrollToGadget(gadget) {
    let $iframeContents = $(iframeId).contents()
    let target = $iframeContents.find("#"+gadget.type+"_gadget")
    $iframeContents.find('html, body').animate({
      scrollTop: $(target).offset().top
    }, 1000);
  }

  function redrawIframe() {
    let iframe = $(iframeId)[0]
    if (iframe) {
      let iframedoc = iframe.contentDocument || iframe.contentWindow.document
      return compilePreview().then(resp => {
        iframedoc.open()
        iframedoc.write(resp.data.html)
        iframedoc.close()
      })
    }

    return $q.when(false)
  }

  /* Gadget Selection */
  $scope.openGadgetSelector = () => {
    $scope.gadgetSelectorOpen = true;
  }

  /*Field Setters and Management*/
  $scope.setDeliveryScheduleType = (scheduleType) => {
    $scope.alert.schedule.scheduleType = scheduleType

    filterDisabledGadgets()
    initScheduleDayIfEmpty()
    updateDayRange(scheduleType)
  }

  function initScheduleDayIfEmpty() {
    if(!$scope.alert.schedule.scheduleDay || !$scope.alert.schedule.scheduleDay.length) {
      $scope.alert.schedule.scheduleDay = [1]
    }
  }

  $scope.getRecipientIndex = getRecipientIndex
  function getRecipientIndex(type) {
    var index = $scope.alert.recipients.indexOf($scope.alert.recipients.find((element,index) => (element.type===type)))
    return index;
  }

  function cleanEmptyRecipientField() {
    $scope.alert.recipients = $scope.alert.recipients.filter( r => ((r.roles && r.roles.length) || (r.userIds && r.userIds.length)))
  }

  function initializeRecipientField() {
    if(!$scope.alert.recipients.find(item => (item.type === "specificUsers"))){
      $scope.alert.recipients.push(angular.copy(initializedRecipients.specificUsers))
    }
    if(!$scope.alert.recipients.find(item => (item.type === "byRole"))){
      $scope.alert.recipients.push(angular.copy(initializedRecipients.role))
    }
  }


  /* CRUD */

  $scope.save = (form) => {
    if($scope.handleFailedNavAttempt(form,form.$invalid)) {
      return;
    }

    $scope.nextAttemptFailed = false
    cleanEmptyRecipientField()
    // need to massage the location filters into the appropriate format
    if ($scope.filters.locations) {
      $scope.alert.filter = $scope.alert.filter || {}
      $scope.alert.filter.locationIds = []
      $scope.alert.filter.groupIds = []
      $scope.filters.locations.forEach(id => {
        if (_.startsWith(id, "location-")) {
          $scope.alert.filter.locationIds.push(id.replace(/^location-/, ''))
        } else if (_.startsWith(id, "group-")) {
          $scope.alert.filter.groupIds.push(id.replace(/^group-/, ''))
        }
      })
    }


    compileGadgetPartials($scope.alert);

    templateService.delimitBy(['<%', '%>']);
    $scope.alert.template = $scope.aceModel.html
    updateAlertStylesheet()
    $scope.alert.stylesheet = $scope.alert.stylesheet || ""
    persistInheritedFilters()

    emailAlertService.saveAlert($scope.alert).then(
      function successHandler(resp) {
        // Only navigate away if no error occurred
        goToDynamicURL(`/#/emailAlerts/manage`);
      },
      function errorHandler(resp) {
        if (resp.data.message !== undefined) {
          $scope.errorMessage = resp.data.message
        } else {
          $scope.errorMessage = "Something went wrong while saving this alert. Please try again."
        }
      })
  }

  function persistInheritedFilters() {
    $scope.alert.gadgets.forEach(gadget => {
      let inheritedGadget = $scope.getInheritedGadget(gadget)
      if(inheritedGadget){
        gadget.filters.forEach( filter => (gadget[filter.name] = inheritedGadget[filter.name]))
      }
    })
  }

  $scope.cancel = () => {
    goToDynamicURL(`/#/emailAlerts/manage`);
  }

  /* Gadget Display */

  $scope.onMoveGadget = (index,gadget) => {
    !gadget.locationSpecific ?
      $scope.nonLocationSpecificGadgets.splice(index, 1) :
      $scope.locationSpecificGadgets.splice(index, 1)
    onGadgetUpdate(gadget)
  }

  $scope.insertGadget = (gadget) => {
    $scope.alert.gadgets = unionBy([gadget],$scope.alert.gadgets,'type')
    partitionGadgetsByType()
    onGadgetUpdate(gadget)
  }

  $scope.removeGadget = (index,gadget) => {
    !gadget.locationSpecific ?
      $scope.alert.gadgets.splice(index, 1) :
      $scope.alert.gadgets.splice($scope.nonLocationSpecificGadgets.length + index, 1)

    $scope.alert.gadgets.forEach((g)=> {g.isOpen = false })
    partitionGadgetsByType()
    onGadgetUpdate()
  }

  function onGadgetUpdate(gadget){
    $scope.alert.gadgets = $scope.nonLocationSpecificGadgets.concat($scope.locationSpecificGadgets)
    removeHref()
    updateUnselectedGadgets()
    $scope.alert.gadgets.forEach(g => g.filters.forEach(filter => {
      filter.accessor && typeof filter.accessor.initialize === "function" && filter.accessor.initialize()
    }))

    compilePartials()
    previewAlert(gadget)
  }

  function refreshEditorParentWidth() {
    $scope.tabWidthHack.refreshTabWidth++
  }

  $scope.enabledDayOfWeek = (dayNum) => {
    $scope.alert.schedule.scheduleDay = $scope.alert.schedule.scheduleDay || []
    return (enabled) => {
      if (typeof enabled !== "undefined") {
        if (enabled) {
          $scope.alert.schedule.scheduleDay = _.uniq(_.concat($scope.alert.schedule.scheduleDay, dayNum))
        } else {
          _.remove($scope.alert.schedule.scheduleDay, num => num === dayNum)
        }
      }
      return $scope.alert.schedule.scheduleDay.indexOf(dayNum) !== -1
    }
  }

  function removeHref() {
    $timeout(() => {
      $('.gadget-wrapper .panel-title > a').removeAttr('href')
    })
  }

  function updateUnselectedGadgets() {
    $scope.unselectedGadgets = differenceBy($scope.GADGETS,$scope.alert.gadgets,'type').filter( (gadget) => !gadget.disableFromSelecting )
  }

  $scope.getInheritedGadget = (gadget) => {
    let inherited = gadget.filtersInheritFrom ? $scope.alert.gadgets.find(g => g.type === gadget.filtersInheritFrom) : null
    return inherited
  }

  $scope.parentGadgetExists = (gadget) => {
    return gadget.filtersInheritFrom && $scope.alert.gadgets.find(maybeParent => (maybeParent.type === gadget.filtersInheritFrom))
  }


  /* Errors and Validation */

  $scope.hasError = function (input) {
    if (!input) return;
    return input.$invalid && (!input.$pristine || $scope.alertSubmitted);
  };

  function scrollToFirstInvalidField(form){
    function findErrorFields(field) {
      const errs = []
      if (field.$name.match(/^(forms\.|emailAlertForm)/)) { // would be nice if there was a better way to detect if its a form
        for (let subArray of Object.values(field.$error)) {
          for (let subField of subArray) {
            errs.push(...findErrorFields(subField))
          }
        }
        return errs;
      } else {
        return [field]
      }
    }

    const errs = findErrorFields(form)
    const elements = errs.map(x => $(`[name="${x.$name}"]`)).filter(x => x.length);
    if (elements[0]) {
      $('html, body').animate({
        scrollTop: elements[0].offset().top - 50
      }, 500);
    }
  }

  function handleError(response){
    let errorDetail = 'Please contact support';

    if(response.data && response.data.error.code) {
      let errorCode = response.data.error.code;

      if(errorCode === 'emailAlert.edit.emailAlertName.duplicate'){
        errorDetail = 'This Email alert name already exists. Email alert names must be unique.';
      }
    }

    $scope.errorMsg = 'Error '+$scope.pageStrings.errorAction+' Email alert!';
    $scope.errorDetail = errorDetail;
  }

  $scope.deselectLogo = () => {
    $scope.alert.logo = null
    $scope.sampleData.resellerLogo = emailAlertConfig.data.SAMPLE_DATA.resellerLogo
    previewAlert()
  }

  $scope.refreshData = () => {
    $scope.sampleData = emailAlertConfig.data.SAMPLE_DATA
  }
})
